export default {
  common: {
    Name_of_the_part: 'Name of the part',
    Box_type: 'Box type',
    Match_number: 'Match number',
    Open_the_edition: 'Open edition',
    Move_up: 'Move up',
    Move_down: 'Move down',
    Copy_the_part: 'Copy part',
    Delete_a_part: 'Delete part',
    Length: 'L',
    Width: 'W',
    Height: 'H',
    Expand: 'Expand',
    Sealing_direction: 'Sealing direction',
    Paper_length_direction: 'Paper length direction',
    The_current_version_is_opened_by_the_system: 'The current version is opened by the system',
    Expand_size: 'Expand size',
    Typographic_size: 'Typographic size',
    Number_of_typesetting: 'Number of typesetting',
    Longitudinal: 'Longitudinal',
    Horizontal: 'Horizontal',
    Sealed_with_paper: 'Sealed with paper',
    Mounting_pit: 'Mounting pit',
    Edit_the_pitted_paper: 'Edit pitted paper',
    Packing: 'Packing',
    Click_to_view_the_drawing: 'Click to view the drawing',
    Open_the_version_manually: 'Open the version manually',
    Product_type: 'Product type',
    Paper_degree_direction: 'Paper degree direction',
    Height_direction: 'Height direction',
    Length_direction: 'Length direction',
    No_requirements: 'No requirements',
    Typeset_to_expanded_size: 'Typeset to expanded size',
    Paper_size: 'Paper size',
    Number_of_opened_papers: 'Number of opened papers',
    Available_sealing_degree: 'Available sealing degree',
    Sealing_degree_prompt: 'Multiple sealing degree values separated by commas, flat paper format',
    Typesetting_results: 'Typesetting results',
    Display_all_opening_results: 'Display all opening results',
    Trial_arrangement: 'Trial arrangement',
    Boarding_size: 'Boarding size',
    Number_of_stones: 'Number of stones',
    Sealing_degree: 'Sealing degree',
    Open_the_paper: 'Open the paper',
    Number_of_open_papers: 'Number of open papers',
    Paper_opening_loss: 'Paper opening loss',
    Thickness: 'Thickness',
    Size: 'Size',
    Product_Type_Required: 'Product type required',
    Dimension_Type_Required: 'Dimension type required',
    Please_fill_in_the_dimension_height: 'Please fill in the dimension height',
    Length_is_required: 'Length is required',
    Width_is_required: 'Width is required',
    No_data_available: 'No data available',
    Please_select_data_on_the_left: 'Please select data on the left',
    Pit: 'Pit',
    Cost_analysis_data_has_not_yet_been_generated: 'Cost analysis data has not yet been generated',
    Refresh: 'Refresh',
  },
  basicInformation: {
    The_pitted_paper_you_choose_is_special_paper_and_the_available_sealing_degree_is: 'The pitted paper you choose is special paper, and the available sealing degree is',
    Does_not_conform_to_the_opening_size: 'Does not conform to the opening size',
    The_format_of_the_seal_information_input_is_not_uniform_and_the_opening_data_cannot_be_obtained: 'The format of the seal information input is not uniform, and the opening data cannot be obtained!',
    The_expansion_dimension_is_automatically_calculated_successfully: 'The expansion dimension is automatically calculated successfully',
    If_there_is_any_size_deviation_please_go_to_the_opening_page_to_manually_modify_the_opening: 'If there is any size deviation, please go to the opening page to manually modify the opening',
    The_automatic_calculation_of_the_expansion_dimensions_failed: 'The automatic calculation of the expansion dimensions failedThe automatic calculation of the expansion dimensions failed. The relevant calculation formula may not be set! Please go to the opening page to manually open the version.',
    Typeset_size_format_entered_is_incorrect: 'Typeset size format entered is incorrect',
    The_modified_layout_size_is_out_of_range: 'The modified layout size is out of range (the modified range of left and right values is in',
    Within: 'Within',
    The_format_of_the_expanded_dimension_entered_is_incorrect: 'The format of the expanded dimension entered is incorrect',
    Platoon: 'Platoon',
    Use_paper: 'Use paper',
    Loss: 'Loss',
    Please_enter_the_expansion_dimension: 'Please enter the expansion dimension',
    Please_enter_the_product_size: 'Please enter the product size',
    There_is_no_sealing_information_for_the_material: 'There is no sealing information for the material. Please go to the opening page to manually open the version.',
  },
  basicInformationwbox: {
    input_format200100: 'Input format: 200*100',
    process: 'Woodworking process',
    lots_use: "Multiple sealing degree values separated by commas, flat paper format (31*43, 35*47)",
    useable_fd: 'Available sealing degree',
    open_v: "Open edition",
    open_v_hand: 'Manual open edition',
    pro_type: 'Product type:',
    paper_dre: 'Paper degree direction:',
    H_dre: 'H Height direction',
    L_dre: 'L Length direction',
    N_dre: 'N No requirements',
    Nail_opening: 'Nail opening (MM):',
    Socket: 'Socket (MM):',
    product_size: 'Product size',
    expand: 'Expand:',
    fd_dre: 'Sealing degree direction:',
    Layout_size: 'Layout size:',
    use_paper_size: 'Paper size:',
    open_paper_sum: 'Number of opened papers',
    useable_sealing_degree: 'Available sealing degree (inches):',
    layout_result: 'Layout results:',
    open_toSee: 'Display all opening results',
    try_lay: 'Trial layout',
    confirm: 'Confirm',
    layout_number: 'Number of layouts',
    upCar_size: 'Boarding size',
    rock_num: 'Number of stones',
    sealing_degree: 'Sealing degree',
    open_paper: 'Open paper',
    o_p_loss: 'Paper opening loss',
    painting: 'Painting',
    scrap_paint: 'Scrap and repaint',
    paint_surface: 'Paint surface',
    paint_process: 'Painting process',
    scrap_youqi: 'Scrap and repaint',
    yq: 'Paint',
    yqm: 'Paint surface',
    chose: 'Choose',
    processno: 'Process number',
    processname: 'Process name',
    param: 'Parameter',
    size1: 'Size 1',
    size2: 'Size 2',
    pro_mustchose: 'Product type must be selected',
    size_type_must_chose: 'Size type must be selected',
    s_m_p: 'Length must be filled',
    w_m_p: 'Width must be filled',
    paint5: '5-sided painting',
    paint6: '6-sided painting',
    no_data_now: 'No data available',
    chose_left: 'Please select data on the left',
    input_size_first: 'Please enter size information first',
    com_info: 'Please complete the parameter information',
    fail_p_input_flag_size: 'Opening failed - please enter flat size information',
    fail_p_input_woold_info: 'Opening failed - please select wood information',
    counting: 'Calculating layout',
    butongyi: 'The input sealing degree information format is not uniform and cannot obtain opening data!',
    layout_format_wrong: 'Incorrect format for the layout size input!',
    outrange1: 'The modified layout size exceeds the range (the modification range of left and right values is',
    outrange2: 'INCHes)',
    expandformwrong: 'Incorrect format for the expanded size input!',
    check_size: 'Please check the input size information for errors!',
    check_format: 'Incorrect format for the size information input!',
    chose_item: 'Please select an item',
    hand_input_p: 'The material does not have available sealing degree information, please enter manually!',
    seal_degree_input: 'Please enter available sealing degree information',
    data_counting: 'Data calculation in progress',
    no_fit_data: 'No suitable opening data, please manually open on the opening page!',
    no_fit_da: 'No suitable opening data',
    chose_result: 'Please select the calculation result',
  },
  materialWindow: {
    Material: 'Material',
    Material1: 'Material',
    Material_type: 'Material type',
    Please_select_a_material_type: 'Please select a material type',
    Please_select_a_material: 'Please select a material',
    Default_item: 'Default material',
    Material_selection: 'Material selection',
    Roll_paper: 'Roll paper',
    Pit_cardboard: 'Pit cardboard',
    Other_materials: 'Other materials',
    Timber: 'Timber',
    Consultation: 'Consultation',
    Blister: 'Blister',
    AcMq: 'Self-adhesive (Die-cut)',
    Selected_items: 'Selected materials',
    Item_attributes: 'Material attributes',
    Subclass_coding: 'Subclass coding',
    Subclass_name: 'Subclass name',
    Bigclass_coding: 'Bigclass coding',
    Bigclass_name: 'Bigclass name',
    Brand_code: 'Brand code',
    Brand_name: 'Brand name',
    Gram_weight: 'Gram weight',
    Classification_code: 'Classification code',
    Classification_name: 'Classification name',
    Enter_a_Wood_Number_or_Name_Search: 'Enter wood number or name to search',
    Searching: 'Searching',
    Wood_coding: 'Wood coding',
    Wood_name: 'Wood name',
    Thickness: 'Thickness',
    Please_select_stock_type: 'Please select paper type',
    Please_select_a_brand: 'Please select a brand',
    Please_select_the_gram_weight: 'Please select gram weight',
    Data_is_being_loaded: 'Data is being loaded',
    Please_select_a_wood_classification: 'Please select wood classification',
    Please_select_wood_information: 'Please select wood information',
    Please_select_category_information: 'Please select category information',
    Please_select_thickness_information: 'Please select thickness information',
    Please_select_the_material_category: 'Please select the material category',
    Please_select_material_sub_category: 'Please select material sub-category',
    Please_enter_the_requirements_for_bursting_strength_and_edge_compression_strength: 'Please enter the requirements for bursting strength and edge compression strength',
  },
  linkageDropdown: {
    firstVal: 'First level linkage',
    secondVal: 'Second level linkage',
    thirdVal: 'Third level linkage',
    select: 'Please select',
  },
  procedureParameter: {
    isProcedureEnable: 'Enable process',
    processType: 'Process category',
    process: 'Process',
  },
  materialChoice: {
    item_type: 'Material type',
    chose_item_type: 'Please select material type',
    paper_type: 'Paper type',
    paper_type_chose: 'Please select paper type',
    brand: 'Brand',
    chose_brand: 'Please select brand',
    k_weight: 'Gram weight',
    chose_k_w: 'Please select gram weight',
  },
  procedureChoice: {
    Customize: 'Customize',
    Process: 'Process',
    Other_processes: 'Other processes',
    Assemble: 'Assemble',
    Process_parameters_to_be_selected: 'Process parameters to be selected',
    Estimated_order_number: 'Estimated order number',
    Operation_selection: 'Operation selection',
    Type: 'Type',
    Please_enter_operation_number_or_name_to_search: 'Please enter operation number or name to search',
    Number: 'Number',
    The_material_price_has_been_included_in_the_labor_cost_unit_price_of_this_operation: 'The material price has been included in the labor cost unit price of this operation',
    Operation_name: 'Operation name',
    Small_process: 'Small process',
    Please_select: 'Please select',
    Operation_description: 'Operation description',
    Ergonomics_estimation: 'Ergonomics estimation',
    Parameter_name: 'Parameter name',
    Parameter_value: 'Parameter value',
    Area: 'Area',
    Select_an_item: 'Select an item',
    Edit_the_pitted_paper: 'Edit pitted paper',
    Part_number: 'Part number',
    Material_name: 'Material name',
    Size_long: 'Size long',
    Size_wide: 'Size wide',
    Size_high: 'Size high',
    Attribute: 'Attribute',
    Operation_selected: 'Operation selected',
    Pit_paper: 'Pit paper',
    Pit_plate: 'Pit plate',
    Common_process: 'Common process',
    Please_select_the_operation_to_be_modified: 'Please select the operation to be modified',
    Failed_to_get_process_parameter: 'Failed to get process parameter',
    Mounting_card_box_automatic_machine_burying: 'Mounting card box, automatic machine burying',
    Mounting_card_box_automatic_machine_buried_mouth_buckle_bottom: 'Mounting card box, automatic machine burying + buckle bottom',
    Mounting_card_box_automatic_machine_burying_button_sticking_hanging_head: 'Mounting card box, automatic machine burying + button sticking + hanging head',
    Single_pit_automatic_machine_buried: 'Single pit, automatic machine burying',
    Double_pit_automatic_machine_buried: 'Double pit, automatic machine burying',
    Mounting_card_box_burying_mouth: 'Mounting card box, burying mouth',
    Single_pit_buried: 'Single pit, burying mouth',
    Double_pit_buried: 'Double pit, burying mouth',
    Mounting_card_box: 'Mounting card box',
    Single_pit: 'Single pit',
    Double_pit: 'Double pit',
    Mounting_card_box_semi_automatic_machine_buried_mouth: 'Mounting card box, semi-automatic machine burying mouth',
    Single_pit_semi_automatic_machine_buried: 'Single pit, semi-automatic machine burying',
    Double_pit_semi_automatic_buried_port: 'Double pit, semi-automatic machine burying port',
    Beer_printing_sheet: 'Beer printing sheet',
    Please_check_the_operation_on_the_left: 'Please check the operation on the left',
    Yes: 'Yes',
    No: 'No',
    Efficiency: 'Efficiency',
    Number_of_people: 'Number of people',
    Pre_work_efficiency: 'Pre-work efficiency',
    You_have_selected_a_manual_operation_An_operation_description_must_be_entered_for_this_operation: 'You have selected a manual operation. An operation description must be entered for this operation',
    You_have_selected_a_laser_engraving_operation_for_which_area_information_must_be_entered: 'You have selected a laser engraving operation for which area information must be entered',
    The_material_price_has_been_included_in_the_labor_cost_unit_price_of_this_operation: 'The material price has been included in the labor cost unit price of this operation',
    Please_check_the_operation_on_the_left_first: 'Please check the operation on the left first',
    Please_select_an_operation_first: 'Please select an operation first',
    Please_select_pit_paper_on_the_left: 'Please select pit paper on the left',
    Please_select_an_item_on_the_left_to_insert: 'Please select an item on the left to insert',
    Please_select_Insert_Target_Row_on_the_right: 'Please select insert target row on the right',
    This_is_the_first_line_and_cannot_be_moved_up: 'This is the first line and cannot be moved up',
    Please_select_to_move_up_the_target_row_on_the_right: 'Please select to move up the target row on the right',
    This_is_the_last_line_cannot_move_down: 'This is the last line and cannot move down',
    Please_select_Move_Down_Target_Row_on_the_right: 'Please select move down target row on the right',
    Facial_paper: 'Facial paper',
    Bottom_paper: 'Bottom paper',
    Layer: 'Layer',
    Please_select_the_type_of_pit_paper: 'Please select the type of pit paper',
    Please_select_pit_paper_pit_type: 'Please select pit paper pit type',
    No_pit_paper_is_selected: 'No pit paper is selected',
    The_numb_of_layers_of_that_pit_pap_is_at_least_2: 'The number of layers of that pit paper is at least 2',
    Pit_paper_should_be_even: 'Pit paper should be even',
    The_number_of_layers_of_the_pit_plate_shall_be_at_least_3: 'The number of layers of the pit plate shall be at least 3',
    Pit_plates_shall_be_odd_numbered: 'Pit plates shall be odd numbered',
    This_element_is_already_the_first_element: 'This element is already the first element',
    This_element_is_already_the_last_element: 'This element is already the last element',
  },
  processEfficiency: {
    work_pre: 'Work efficiency estimation',
    estimate_no: 'Estimate number:',
    estimate_rate: 'Estimate efficiency:',
    estimate_people: 'Estimate people:',
    to_ie: 'To IE engineer:',
    estimate_date: 'Expected reply period:',
    procedure_desc: 'Process description',
    pro_pre_desc: 'Process estimation description',
    add_file: 'Please add a file',
    atta_file: 'Attachment',
    file_name: 'File name',
    op: 'Operation',
    load_down: 'Download',
    not_be_modify: 'This work efficiency estimation already has a reply, cannot be modified!',
    t0_null: 'TO information cannot be empty!',
    expect_null: 'Expected reply period cannot be empty!',
    pro_null: 'Process estimation description cannot be empty!',
    keep_ornot: 'Cancel operation will clear the previous work efficiency estimation information, continue?',
    clear: 'Work efficiency estimation cleared successfully!',
    upload_suc: 'Upload successful',
    upload_max: 'Maximum file size can be 10M',
    confirm_del: 'Confirm removal',
  },
  procedureChoiceMaterial: {
    new_item: 'New material',
    category: 'Category',
    item_small_type: 'Material subclass',
    item_code: 'Material number',
    item_name: 'Material name',
    f_degree: 'Sealing degree',
    it_size: 'Material size',
    req: 'Request reply deadline:',
    spec: 'Material specification',
    unit: 'Usage unit',
    count_way: 'Pricing method',
    gc: 'Tolerance requirement',
    pack_re: 'Packing requirement',
    test_re: 'Test requirement',
    remark_re: 'Test requirement remark',
    address: 'Delivery address',
    attach_file: 'Material attachment',
    item_chose: 'Material selection',
    item_type: 'Material type',
    input_item: 'Please enter material number or name to search',
    search: 'Search',
    select: 'Select',
    attribute: 'Attribute',
    guige: 'Specification',
    validity: 'Validity',
    modify_item: 'Modify material attribute',
    set_item: 'Set material',
    purchase_item: 'Purchased materials',
    asked_item: 'Inquired materials',
    cannot_be_change: 'The material already has price information, cannot be modified!',
    input_keyword: 'Please enter keywords',
    select_process: 'Please select a process first',
    upload_suc: 'Upload successful',
    upload_max: 'Maximum file size can be 10M',
    Are_you_sure_to_remove: 'Confirm removal',
    null_itemname: 'Material name cannot be empty!',
    null_seal: 'Please enter the correct sealing degree information!',
    null_to_dept: 'TO department cannot be empty!',
    null_ddl: 'Request reply deadline cannot be empty!',
    null_itemspec: 'Material specification cannot be empty!',
    null_unit: 'Usage unit cannot be empty!',
    null_test_request: 'Test requirement cannot be empty!',
    null_test_remark: 'Test requirement remark cannot be empty!',
    null_errand: 'Tolerance requirement cannot be empty!',
    null_pack_re: 'Packing requirement cannot be empty!',
    null_de_address: 'Delivery address cannot be empty!',
    null_count_way: 'Pricing method cannot be empty!',
    null_catagory: 'Category cannot be empty!',
    null_small_ca: 'Material subclass cannot be empty!',
    try_later: 'LQ table data error，try later',
    check_left: 'check left process first',
    chose_one: 'only one material can be selected',
    There_is_a_sample: 'There is a sample',
  },
  printColor: {
    Printing_color: 'Printing color',
    Front_printing_color: 'Front',
    Spot_color_please_go_to_more_to_enter: 'Spot color, please go to more to enter',
    Please_select_over_oil: 'Please select over oil',
    Underside_printing: 'Underside',
    No_printing_color: 'No printing color',
    Face_printing_color: 'Face printing color',
    Primary_Color: 'Primary color',
    Please_select_a_printing_plate: 'Please select a printing plate',
    General_and_special: 'General and special',
    Plate_printing_machine: 'Plate printing machine',
    Metal_fluorescent_special: 'Metal/fluorescent special',
    White_ink: 'White ink',
    Connect_the_machine_for_oil_passing: 'Connect the machine for oil passing',
    Bottom_print_color: 'Bottom printing color',
    Ordinary: 'Ordinary',
    Word_version: 'Word version',
    Earth: 'Earth',
    Dye_the_paper: 'Dye the paper',
    Ordinary_printing: 'Ordinary printing',
    UV_printing: 'UV printing',
    Printed_on_one_side: 'Printed on one side',
    Printed_on_both_sides: 'Printed on both sides',
    Failed_to_load_the_online_oiling_data_source: 'Failed to load the online oiling data source',
  },
  customerChoice: {
    selectPlaceholder: 'Please enter at least 4 characters',
    validHint: "You do not have permission to view this customer's quote information",
  },
  basicInformationbbkpzz: {
    finish_product: 'Finish product',
    component: 'Component',
    ppnum0: 'PP number',
    ppnum: 'PP number per edition',
    match_num: 'Match number',
    paper_re: 'Paper texture requirement',
    direction: 'Spine direction',
    vertical: 'Vertical to the spine',
    no_need: 'No requirements',
    pull: 'Pull page',
    same_ver: 'Same edition',
    bs: 'Edition number',
    ms: 'Module number',
    ex_size: 'Expand size',
    pro_size: 'Product size',
    size_200100: 'Input format: 200*100',
    sys_open_v: 'System calculated opening',
    pp_per: 'PP number per fold',
    break_num: 'Number of folds',
    open_v: 'Opening',
    product_type: 'Product type',
    zds: 'Straight book',
    hds: 'Horizontal book',
    link_num: 'Number of linked books',
    link_book: 'Linked book',
    no_select: 'Not selected',
    lay_size: 'Layout size',
    paper_size: 'Paper size',
    open_paper_size: 'Number of opened papers',
    usable_degree: 'Available sealing degree (inches)',
    many_degree: 'Multiple sealing degree values separated by commas',
    op_result: 'Opening results',
    show_all_v: 'Display all opening results',
    try_lay: 'Trial layout',
    lay_num: 'Number of layouts',
    pucar_size: 'Boarding size',
    paper_d: 'Paper texture direction',
    rock_num: 'Number of stones',
    Paper_degree_direction: 'Paper degree direction',
    Open_according_to_the_expanded_size: 'Open according to the expanded size',
    Shell: 'Shell',
    Title_page: 'Title page',
    Color_page: 'Color page',
    Nevin: 'Nevin',
    Fold: 'Fold',
    Modify_layout_size_out_of_range: 'Modify layout size out of range',
    The_modification_range_of_the_left_value_is_in_the: 'The modification range of the left value is in the',
    The_modification_range_of_the_right_value_is_in_the: 'The modification range of the right value is in the',
    Cover_has_the_wrong_expanded_size: 'Cover has the wrong expanded_size',
    input_nevin_size:'input_the_nevin_size',
  },
  materialSelected: {
    Select_a_material: 'Select a material',
    See_the_pit: 'See the pit',
    Cardboard: 'Cardboard',
    All: 'All',
    Facial_paper: 'Facial paper',
    Core_paper: 'Core paper',
    Please_enter_the_content: 'Please enter the content',
    Insert_before_the_selected_row: 'Insert before the selected row',
    Insert: 'Insert',
    Move_up: 'Move up',
    Move_down: 'Move down',
    Intelligent_matching: 'Intelligent matching',
    Leng_type: 'Flute type',
    Please_select_the_flute_type: 'Please select the flute type',
    Please_select_pit_paper: 'Please select pit paper',
    Selection_of_only_one_layer_is_not_allowed: 'Selection of only one layer is not allowed',
    The_number_of_cardboard_pit_paper_layers_should_be_an_odd_number: 'The number of cardboard pit paper layers should be an odd number',
    The_number_of_matching_paper_layers_of_the_pit_paper_should_be_even: 'The number of matching paper layers of the pit paper should be even',
    The_number_of_layers_of_pit_paper_does_not_match_the_corrugation_type: 'The number of layers of pit paper does not match the corrugation type',
    Warm_tips: 'Warm tips',
  },
  packingArrange2D: {
    Volume_size: 'Volume size',
    Available_clear_height: 'Available clear height',
    Calculation: 'Calculation',
    Result: 'Result',
    Total_number_of_cases: 'Total number of cases',
    Wide_row: 'Wide row',
    Long_row: 'Long row',
    Turn_around: 'Turn around',
    Plane_loading_rate: 'Plane loading rate',
    Three_dimensional_loading_rate: 'Three-dimensional loading rate',
    Swing_high: 'Swing high',
    Number_of_cartons: 'Number of cartons',
    Number_of_cards: 'Number of cards',
    The_total_number_of_boxes_is_too_large_to_draw_the_layout: 'The total number of boxes is too large to draw the layout',
    Calculation_failed: 'Calculation failed',
  },
  baidu: {
    Baidu_ranging: 'Baidu ranging',
    Select_an_address: 'Select an address',
    Please_enter_an_address_keyword: 'Please enter an address keyword',
    Current_route_distance: 'Current route distance',
    Ranging: 'Ranging',
    You_have_not_selected_a_location: 'You have not selected a location',
    Please_select_the_starting_point_information_first: 'Please select the starting point information first',
    The_latitude_and_longitude_information_is_not_set_for_the_starting_point: 'The latitude and longitude information is not set for the starting point',
  },
  quoteReturnRecordList: {
    title: 'Quote Return Record List',
    RequestCode: 'Quote Code',
    CustomerCode: 'Customer Code',
    CustomerName: 'Customer Name',
    Deptname: 'Department',
    QuoteCreateUserName: 'Quote Creator',
    ReturnReasons: 'Return Reasons',
    ReturnDate: 'Return Date',
  }
}



// WEBPACK FOOTER //
// ./src/components/local/en.js